import React from 'react';

const Trustedpartner = ({ logos, customClass }) => {
  return (
    <section className={`trusted-partner-section ${customClass}`}>
      <div className="trusted-partner-content">
        <h2 className="trusted-section-title">Our Trusted Clients</h2>
        <p className="trusted-section-description">Our achievements showcase our expertise in delivering compliant employment solutions. Count on us to manage your global workforce seamlessly and efficiently.
        </p>
      </div>
      <div className="client-logos-container">
        {logos.map((logo, index) => (
          <div key={index} className="client-logo-item">
            <img src={logo.src} alt={logo.alt} className="client-logo" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Trustedpartner;
